// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ef3b7d4ec13f3a025ce3","678":"05f0ff8337d95873afc5","883":"d2660be6923d7d1a3e26"}[chunkId] + ".js";
};